import {
  GET_DATA_SOURCES_SUCCESS,
  GET_DATA_SOURCES_FAILURE,
  GET_DATA_SOURCE_SUCCESS,
  ADD_DATA_SOURCE_SUCCESS,
  COPY_DATA_SOURCE_SUCCESS,
  ADD_DATA_SOURCE_FAILURE,
  COPY_DATA_SOURCE_FAILURE,
  UPLOAD_FILE_TO_SOURCE_SUCCESS,
  LOGOUT_COMPLETE,
  DELETE_SOURCE_SUCCESS,
  DELETE_PIPELINE_SUCCESS,
} from '../../constants/actionTypes';

import map from 'lodash/map';
import filter from 'lodash/filter';
import reduce from 'lodash/reduce';
import indexOf from 'lodash/indexOf';
import has from 'lodash/has';
import isNil from 'lodash/isNil';
import size from 'lodash/size';
import isArray from 'lodash/isArray';

const initialState = {
  lastUpdated: null,
  byId: [],
  summaryById: {},
  lastAddedId: null,
  lastFileUploaded: null,
  error: null,
};

export const sourcesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DATA_SOURCES_SUCCESS:
      return saveDataSources(state, action);

    case GET_DATA_SOURCES_FAILURE:
      return removeDataSources(state, action);

    case GET_DATA_SOURCE_SUCCESS:
      return saveDataSource(state, action);

    case ADD_DATA_SOURCE_SUCCESS:
    case COPY_DATA_SOURCE_SUCCESS:
      return addDataSource(state, action);

    case UPLOAD_FILE_TO_SOURCE_SUCCESS:
      return uploadFileToSource(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    case DELETE_SOURCE_SUCCESS:
      return deleteDataSource(state, action);

    case DELETE_PIPELINE_SUCCESS:
      return deletePipeline(state, action);

    case ADD_DATA_SOURCE_FAILURE:
    case COPY_DATA_SOURCE_FAILURE:
    default:
      return state;
  }
};

export default sourcesReducer;

function saveDataSources(state, action) {
  let {
    result,
    entities: { sources },
  } = action;
  let summaryById = {};
  if (!isNil(sources)) {
    summaryById = reduce(
      sources,
      (acc, v) => {
        const dataSetsCount =
          has(v, 'data_sets') && !isNil(v.data_sets) && isArray(v.data_sets)
            ? size(v.data_sets)
            : 0;
        acc[v.id] = { data_sets: dataSetsCount };
        return acc;
      },
      {},
    );
  }

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: result,
    error: null,
    summaryById,
  };
}

function saveDataSource(state, action) {
  const { result } = action;

  const thisSource =
    !isNil(result) && has(action, `entities.sources[${result}]`)
      ? action.entities.sources[result]
      : null;
  let summaryById = state.summaryById;

  if (!isNil(thisSource)) {
    const thisSourceSummary =
      has(thisSource, 'data_sets') && !isNil(thisSource.data_sets) && isArray(thisSource.data_sets)
        ? { data_sets: size(thisSource.data_sets) }
        : { data_sets: 0 };
    summaryById = { ...state.summaryById, [result]: thisSourceSummary };
  }

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: indexOf(state.byId, result) === -1 ? [...state.byId, result] : [...state.byId],
    error: null,
    summaryById,
  };
}

function removeDataSources(state, action) {
  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: [],
    error: action.error,
  };
}

function addDataSource(state, action) {
  let { result } = action;

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: indexOf(state.byId, result) === -1 ? [...state.byId, result] : [...state.byId],
    lastAddedId: result,
    error: null,
  };
}

function uploadFileToSource(state, action) {
  return {
    ...state,
    lastFileUploaded: action.receivedAt,
  };
}

function deleteDataSource(state, action) {
  let {
    requestInfo: { id },
  } = action;
  let deletedSourceId = id;
  let newById = filter(state.byId, (sId) => sId !== deletedSourceId);

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: newById,
    error: null,
  };
}

function deletePipeline(state, action) {
  let {
    requestInfo: { deletedItems },
  } = action;
  let deletedSourceIds = map(
    filter(deletedItems, (item) => item.type === 'SOURCE'),
    'data_source_id',
  );
  let newById = filter(state.byId, (sId) => !deletedSourceIds.includes(sId));

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: newById,
    error: null,
  };
}
